import { post, remove } from '../api';

export const ORGANIZATION_ACCESS_REQUEST_INVITE_EXISTING = 'ORGANIZATION_ACCESS_REQUEST_INVITE_EXISTING';
export const ORGANIZATION_ACCESS_REQUEST_REMOVE_ACCESS_REQUEST = 'ORGANIZATION_ACCESS_REQUEST_REMOVE_ACCESS_REQUEST';

const organizationAccessRequestActions = {
  inviteExisting: (organizationId: number, accessRequestId: number) => ({
    type: ORGANIZATION_ACCESS_REQUEST_INVITE_EXISTING,
    async payload() {
      return post(`/api/organizations/${organizationId}/access-requests/${accessRequestId}/accept`, undefined);
    },
  }),
  removeAccessRequest: (organizationId: number, accessRequestId: number) => ({
    type: ORGANIZATION_ACCESS_REQUEST_REMOVE_ACCESS_REQUEST,
    meta: { accessRequestId },
    async payload() {
      return remove(`/api/organizations/${organizationId}/access-requests/${accessRequestId}`);
    },
  }),
};

export default organizationAccessRequestActions;
